import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import styles from "../../styles/components/editorPendingPublicationTable.module.scss";
import React, { useState } from "react";
import EyeTableIcon from "../../public/assets/icons/EyeTableIcon";
import thumb1 from "../../public/assets/images/tab_thumbnail_1.jpg";
import thumb2 from "../../public/assets/images/tab_thumbnail_2.jpg";
import thumb3 from "../../public/assets/images/tab_thumbnail_3.jpg";
import thumb4 from "../../public/assets/images/tab_thumbnail_4.jpg";
import thumb5 from "../../public/assets/images/tab_thumbnail_5.jpg";
import thumb6 from "../../public/assets/images/tab_thumbnail_6.jpg";
import thumb7 from "../../public/assets/images/tab_thumbnail_7.jpg";
import thumb8 from "../../public/assets/images/tab_thumbnail_8.jpg";
import thumb9 from "../../public/assets/images/tab_thumbnail_9.jpg";
import thumb10 from "../../public/assets/images/tab_thumbnail_10.jpg";
import thumb11 from "../../public/assets/images/tab_thumbnail_11.jpg";
import thumb12 from "../../public/assets/images/tab_thumbnail_12.jpg";
import thumb13 from "../../public/assets/images/tab_thumbnail_13.jpg";
import thumb14 from "../../public/assets/images/tab_thumbnail_14.jpg";
import thumb15 from "../../public/assets/images/tab_thumbnail_15.jpg";
import thumb16 from "../../public/assets/images/tab_thumbnail_16.jpg";
import thumb17 from "../../public/assets/images/tab_thumbnail_17.jpg";
import thumb18 from "../../public/assets/images/tab_thumbnail_18.jpg";
import thumb19 from "../../public/assets/images/tab_thumbnail_19.jpg";
import thumb20 from "../../public/assets/images/tab_thumbnail_20.jpg";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import { TablePagination } from "@material-ui/core";
import EmptyTable from "../EmptyTable/EmptyTable";
import NoResultTable from "../NoResultTable/NoResultTable";
import {
  concatHostAndImagePath,
  getUtcDate,
  getUtcTime,
  roleFinder,
} from "../../lib/functions/utils.lib";
import VideoPageFullModal from "../VideoPages/pages/VideoPageFullModal";
import WatchVideoModal from "../VideoPages/pages/WatchVideoModal";
import { useAppSelector } from "../../hooks/useAppSelector";
import NoResultTwo from "../NoResult/NoResultTwo";
import OopsIcon from "../../public/assets/icons/OopsIcon";
import PaginationTwo from "../UtilitiesComponent/PaginationTwo";
import EditorDashboardVideoModal from "../VideoPages/pages/EditorDashboardVideoModal";

function createData(
  vsid,
  acquisitor,
  thumbnail,
  title,
  submitter,
  email,
  published
) {
  return { vsid, acquisitor, thumbnail, title, submitter, email, published };
}

const rows = [
  createData(
    "13194",
    <>Theodore</>,
    <>
      <img src={thumb1} alt="" />
    </>,
    "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Maxime Barronier</>,
    <>
      <img src={thumb2} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Muhammad Ali Waqas</>,
    <>
      <img src={thumb3} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      August 6, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Theodore Doulkeris</>,
    <>
      <img src={thumb4} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>
      Maxime Barronier <span>Content Buyer</span>
    </>,
    <>
      <img src={thumb5} alt="" />
    </>,
    "Girl Tries Hitting a Car with Her Hand at a Traffic Light",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      June 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>
      Theodore <span>Partner</span>
    </>,
    <>
      <img src={thumb6} alt="" />
    </>,
    "Girl Gets Surprised with a Baby Yoda Toy That She Wanted for So Long",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      January 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Maxime Barronier</>,
    <>
      <img src={thumb1} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      October 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>
      Maxime Barronier <span>Content Buyer</span>
    </>,
    <>
      <img src={thumb7} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Maxime Barronier</>,
    <>
      <img src={thumb8} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      April 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>
      Awais <span>Member</span>
    </>,
    <>
      <img src={thumb9} alt="" />
    </>,
    "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      March 30, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Awais</>,
    <>
      <img src={thumb10} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      November 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Awais</>,
    <>
      <img src={thumb11} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Awais</>,
    <>
      <img src={thumb12} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Awais</>,
    <>
      <img src={thumb13} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Awais</>,
    <>
      <img src={thumb14} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Shafeeq Waqas</>,
    <>
      <img src={thumb15} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Shafeeq Waqas</>,
    <>
      <img src={thumb16} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Shafeeq Waqas</>,
    <>
      <img src={thumb17} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Avraam Pedritis</>,
    <>
      <img src={thumb18} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Avraam Pedritis</>,
    <>
      <img src={thumb19} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
  createData(
    "13194",
    <>Avraam Pedritis</>,
    <>
      <img src={thumb20} alt="" />
    </>,
    "Rabbit on fence",
    "John Smith",
    "johnsmith@gmail.com",
    <>
      September 26, 2019 <br />
      at 05:45:23 AM UTC
    </>
  ),
];

const EditorPendingPublicationTable = ({ data, handlePageChange, page }) => {
  const { from, to } = useAppSelector((s) => s.editorPendingPublicationSlice);

  const [openModal, setOpenModal] = useState(false);
  const [openModalTwo, setOpenModalTwo] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
    // handleTriggreFetch();
  };
  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };

  return (
    <>
      <TableContainer className={styles.tableMain}>
        <Box>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell className={styles.vsid}>VSID</TableCell>
                <TableCell className={styles.acqui}>Acquisitor</TableCell>
                <TableCell className={styles.thumb}>Thumbnail</TableCell>
                <TableCell className={styles.title}>Title</TableCell>
                <TableCell className={styles.submitter}>
                  Submitter Name
                </TableCell>
                <TableCell className={styles.email}>Email Address</TableCell>
                <TableCell className={styles.publish}>
                  Pending Publication Since
                </TableCell>
                <TableCell className={styles.view} align="center">
                  View
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.data?.length > 0 ? (
                <>
                  {data?.data?.map((row) => (
                    <>
                      <TableRow
                        key={row.vsid}
                        className={
                          row?.video_extra?.urgent_posting_request === 1
                            ? `${styles.tableActive}`
                            : ""
                        }
                      >
                        <TableCell>
                          <Box className={styles.vsidBox}>{row.vsid}</Box>
                        </TableCell>
                        <TableCell>
                          <Box className={styles.acquiBox}>
                            {row?.user?.name ? `${row?.user?.name}` : ""}
                            {row?.user?.last_name
                              ? `${row?.user?.last_name}`
                              : ""}
                            <p className={styles.table_customer}>
                              {roleFinder(row.user?.role_id)}
                            </p>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className={styles.thumbImg}>
                            {" "}
                            <figure onClick={() => onOpenTwo(row.id)}>
                              <img
                                src={concatHostAndImagePath(row.thumbnail)}
                                width={73}
                                height={46}
                                alt="image"
                              />
                            </figure>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className={styles.titleBox}>{row.title}</Box>
                        </TableCell>
                        <TableCell>
                          {row.first_name ? row?.first_name : ""}{" "}
                          {row?.last_name ? row?.last_name : ""}
                        </TableCell>
                        <TableCell>{row.email}</TableCell>
                        <TableCell>
                          {getUtcDate(row.video_meta?.copywrite_completed_at)}{" "}
                          <br />
                          {getUtcTime(row.video_meta?.copywrite_completed_at)}
                        </TableCell>
                        <TableCell align="center">
                          <Box className={styles.viewIcon}>
                            <Button onClick={() => onOpen(row.id)}>
                              <EyeTableIcon />
                            </Button>
                          </Box>
                        </TableCell>
                      </TableRow>

                      <TableRow className={styles.blnkTd}>
                        <TableCell colSpan={10}>{""}</TableCell>
                      </TableRow>
                    </>
                  ))}
                </>
              ) : (
                <>
                  <TableRow className={styles.noHover}>
                    {from || to ? (
                      <TableCell colSpan={8}>
                        <NoResultTable
                          errText={
                            "  We couldn't find any videos pending publication since the specified date range"
                          }
                        />
                      </TableCell>
                    ) : (
                      <TableCell colSpan={8}>
                        <EmptyTable
                          emptyTableText={
                            "You have no videos pending publication at the moment. Please reload the page or check back later."
                          }
                        />
                      </TableCell>
                    )}
                  </TableRow>
                </>
              )}
              {data?.data?.length > 0 ? (
                <TableRow className={styles.noHover}>
                  <TableCell colSpan={10}>
                    {data.data.length < data?.per_page &&
                      data.last_page == 1 ? (
                      <>
                        <p>
                          End of list. We couldn't find more videos pending
                          publication since the specified date range.
                        </p>
                      </>
                    ) : (
                      <>
                        <PaginationTwo
                          page={page}
                          count={data?.last_page}
                          handleChange={handlePageChange}
                        />
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ) : (
                ""
              )}
            </TableBody>
          </Table>

          {/* <TablePagination/> */}
        </Box>
      </TableContainer>
      <EditorDashboardVideoModal
        onClose={onClose}
        open={openModal}
        id={id}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="videoPageModal"
      />
      <WatchVideoModal
        onClose={onCloseTwo}
        open={openModalTwo}
        id={id}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="videoPageModal"
      />
    </>
  );
};

export default EditorPendingPublicationTable;
